/**
 * Calendar-date helpers that stay in the browser's local zone.
 *
 * Building "today" from `new Date().toISOString().slice(0, 10)` yields the UTC date, which is
 * tomorrow for anyone east of UTC after their local evening and yesterday for US users before
 * 6-8 PM. Anything comparing or defaulting a date-only field should use these instead.
 */

/**
 * Today's calendar date in the browser's local zone as YYYY-MM-DD. Call this at the moment
 * you need it: a value captured once (e.g. in a cached computed) goes stale when a screen is
 * left open past midnight.
 */
export function todayDateOnly(now = new Date()) {
	const year = now.getFullYear();
	const month = String(now.getMonth() + 1).padStart(2, "0");
	const day = String(now.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
}
